import React from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { Calendar, CheckCircle, XCircle, Clock } from 'lucide-react';
export function StoricoPage() {
  const historyItems = [{
    id: 1,
    date: '18 Gen 2024',
    time: '10:30',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 2,
    date: '17 Gen 2024',
    time: '14:00',
    property: 'Appartamento Centro',
    provider: 'LuxuryClean',
    status: 'Completato',
    type: 'Profonda',
    price: '€80,00'
  }, {
    id: 3,
    date: '15 Gen 2024',
    time: '09:00',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 4,
    date: '12 Gen 2024',
    time: '11:30',
    property: 'Appartamento Centro',
    provider: 'LuxuryClean',
    status: 'Annullato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 5,
    date: '10 Gen 2024',
    time: '10:00',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }];
  return <MobileLayout data-id="element-2061">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-2062">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2063">Storico</h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-2064">
          Cronologia di tutti gli interventi
        </p>
      </div>

      {/* Summary Stats - MOVED TO TOP */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6" data-id="element-2065">
        <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-2066">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2067">
            Totale Interventi
          </p>
          <p className="text-2xl lg:text-3xl font-bold text-navy" data-id="element-2068">
            {historyItems.length}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-2069">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2070">
            Completati
          </p>
          <p className="text-2xl lg:text-3xl font-bold text-green-600" data-id="element-2071">
            {historyItems.filter(i => i.status === 'Completato').length}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-2072">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2073">
            Pulizie Effettuate
          </p>
          <p className="text-2xl lg:text-3xl font-bold text-coral" data-id="element-2074">
            {historyItems.filter(i => i.status === 'Completato' && (i.type === 'Ordinaria' || i.type === 'Profonda')).length}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-2075">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-2076">
            Spesa Totale
          </p>
          <p className="text-2xl lg:text-3xl font-bold text-navy" data-id="element-2077">€220,00</p>
        </div>
      </div>

      {/* Filters - Underline tab style */}
      <div className="flex items-center gap-6 mb-6 overflow-x-auto pb-1" data-id="element-2078">
        <button className="pb-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 border-teal-deep text-teal-deep" data-id="element-2079">
          Tutti
        </button>
        <button className="pb-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 border-transparent text-gray-500 hover:text-gray-700" data-id="element-2080">
          Completati
        </button>
        <button className="pb-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 border-transparent text-gray-500 hover:text-gray-700" data-id="element-2081">
          Annullati
        </button>
      </div>

      {/* History List - Mobile: Cards, Desktop: Table */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-2082">
        {/* Mobile: Card Layout */}
        <div className="lg:hidden divide-y divide-gray-100" data-id="element-2083">
          {historyItems.map(item => <div key={item.id} className="p-4 space-y-3" data-id="element-2084">
              <div className="flex items-start justify-between" data-id="element-2085">
                <div data-id="element-2086">
                  <p className="font-medium text-navy text-sm" data-id="element-2087">
                    {item.property}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2088">
                    {item.date} • {item.time}
                  </p>
                </div>
                <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Completato' ? 'bg-green-100 text-green-800' : item.status === 'Annullato' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-2089">
                  {item.status === 'Completato' && <CheckCircle size={12} data-id="element-2090" />}
                  {item.status === 'Annullato' && <XCircle size={12} data-id="element-2091" />}
                  {item.status}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-2092">
                <div data-id="element-2093">
                  <p className="text-gray-500" data-id="element-2094">Fornitore</p>
                  <p className="text-navy font-medium" data-id="element-2095">{item.provider}</p>
                </div>
                <div data-id="element-2096">
                  <p className="text-gray-500" data-id="element-2097">Tipo</p>
                  <p className="text-navy font-medium" data-id="element-2098">{item.type}</p>
                </div>
              </div>
              <div className="pt-2 border-t border-gray-100 flex items-center justify-between" data-id="element-2099">
                <p className="text-sm font-bold text-navy" data-id="element-2100">{item.price}</p>
                <button className="text-xs text-teal-deep hover:underline font-medium" data-id="element-2101">
                  Dettagli
                </button>
              </div>
            </div>)}
        </div>

        {/* Desktop: Table Layout */}
        <div className="hidden lg:block overflow-x-auto" data-id="element-2102">
          <table className="w-full text-sm" data-id="element-2103">
            <thead className="bg-gray-50 border-b border-gray-100" data-id="element-2104">
              <tr data-id="element-2105">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2106">
                  Data
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2107">
                  Proprietà
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2108">
                  Fornitore
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2109">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2110">
                  Prezzo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2111">
                  Stato
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2112">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-2113">
              {historyItems.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-2114">
                  <td className="px-6 py-4 text-gray-600" data-id="element-2115">
                    {item.date}
                    <br data-id="element-2116" />
                    <span className="text-xs text-gray-400" data-id="element-2117">{item.time}</span>
                  </td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-2118">
                    {item.property}
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-2119">{item.provider}</td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-2120">{item.type}</td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-2121">
                    {item.price}
                  </td>
                  <td className="px-6 py-4" data-id="element-2122">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Completato' ? 'bg-green-100 text-green-800' : item.status === 'Annullato' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-2123">
                      {item.status === 'Completato' && <CheckCircle size={12} data-id="element-2124" />}
                      {item.status === 'Annullato' && <XCircle size={12} data-id="element-2125" />}
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2126">
                    <button className="text-sm text-teal-deep hover:underline font-medium" data-id="element-2127">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </MobileLayout>;
}